import { GET, PATCH, POST } from './api'

const BASE_PATH = '/staff/essentials-invites'
const ACCELERATOR_BASE_PATH = '/staff/accelerator-invites'

export const ReadEssentialsInvites = async () => {
	return await GET(BASE_PATH, true)
}

export const CreateEssentialsInvite = async params => {
	return await POST(BASE_PATH, params, true)
}

export const UpdateEssentialsInvite = async (id, params) => {
	return await PATCH(`${BASE_PATH}/${id}`, params, true)
}

export const ReadEssentialsInviteHistory = async id => {
	return await GET(`${BASE_PATH}/${id}/history`, true)
}

export const ReadEssentialsContentCatalog = async (params = {}) => {
	const query = new URLSearchParams()
	Object.entries(params).forEach(([key, value]) => {
		if (value !== '' && value != null) query.set(key, value)
	})
	return await GET(`${BASE_PATH}/content-catalog?${query.toString()}`, true)
}

// Load every page so manual changes preserve access to content outside visible results.
export const ReadAllEssentialsContentCatalog = async () => {
  const first = await ReadEssentialsContentCatalog({ page: 1, pageSize: 100 })
  if (!first || first.error) return first
  const data = [...(first.data || [])]
  for (let page = 2; page <= (first.meta?.pagination?.pageCount || 1); page += 1) {
    const result = await ReadEssentialsContentCatalog({ page, pageSize: 100 })
    if (!result || result.error) return result
    data.push(...(result.data || []))
  }
  return { ...first, data }
}

export const ReadAcceleratorInvites = async () => {
	return await GET(ACCELERATOR_BASE_PATH, true)
}

export const CreateAcceleratorInvite = async params => {
	return await POST(ACCELERATOR_BASE_PATH, params, true)
}

export const UpdateAcceleratorInvite = async (id, params) => {
	return await PATCH(`${ACCELERATOR_BASE_PATH}/${id}`, params, true)
}

export const ReadAcceleratorInviteHistory = async id => {
	return await GET(`${ACCELERATOR_BASE_PATH}/${id}/history`, true)
}
